import axios from "./themeInstance"

export default async (id:string,page = 1, size = 10) => {
  try {
    const response: any = await axios(`/themes/${id}/histories?page=${page}&size=${size}`)
    return response.data
  } catch (error) {
    return null
  }
}
